import React, { useState } from 'react';
import classNames from 'classnames';
import { Route } from 'react-router-dom';

import AppTopBar from './AppTopbar';
import AppFooter from './AppFooter';
import AppConfig from './AppConfig';
import {resetCache} from './utilities/Seguridad'
import AppMenu from './AppMenu';
import AppInlineProfile from './AppInlineProfile';

import { Dashboard } from './components/Dashboard';
import { DashboardBanking } from './components/DashboardBanking';

import { PageFicha } from './pages/registros/PageFicha';
import { PageHorarioCurso } from './pages/configurador/PageHorarioCurso';
import { PageColegio } from './pages/mantenedor/PageColegio';
import { PageFestivo } from './pages/mantenedor/PageFestivo';
import { PageProfesional } from './pages/mantenedor/PageProfesional';
import { PageMatricula } from './pages/registros/PageMatricula';
import { PageAsistencia } from './pages/registros/PageAsistencia';

import { PageUsuario } from './pages/seguridad/PageUsuario';
import { PagePerfilAcceso } from './pages/seguridad/PagePerfilAcceso';
import { Access } from './pages/Access';
import { PageProfile } from './pages/seguridad/PageProfile';
import { PageLibro } from './pages/libro/PageLibro';

import { PageFudei } from './pages/formularios/PageFudei';
import { PageOtro } from './pages/formularios/PageOtro';
import { useHistory } from 'react-router-dom';

import PrimeReact from 'primereact/api';

import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import './App.scss';

import { shallowEqual, useSelector, useDispatch } from 'react-redux'

import { BreadCrumb } from 'primereact/breadcrumb';

import LoadingOverlay from 'react-loading-overlay';
import BounceLoader from 'react-spinners/BounceLoader'

const App = () => {

    const home = { icon: 'pi pi-home' }

    const [menuActive, setMenuActive] = useState(false);
    const [profileMode, setProfileMode] = useState('top');
    const [profileExpanded, setProfileExpanded] = useState(false);
    const [menuMode, setMenuMode] = useState('static');
    const [overlayMenuActive, setOverlayMenuActive] = useState(false);
    const [staticMenuDesktopInactive, setStaticMenuDesktopInactive] = useState(false);
    const [staticMenuMobileActive, setStaticMenuMobileActive] = useState(false);
    const [topbarMenuActive, setTopbarMenuActive] = useState(false);
    const [activeTopbarItem, setActiveTopbarItem] = useState(null);
    const [darkMenu, setDarkMenu] = useState(true);
    const [theme, setTheme] = useState('blue');
    const [layout, setLayout] = useState('blue');
    const [configActive, setConfigActive] = useState(false);
    const [inputStyle, setInputStyle] = useState('outlined');
    const [ripple, setRipple] = useState(false);
    const history = useHistory();

    const [itemsBreadCrumb, setItemsBreadCrumb] = useState(null);

    let menuClick = false;
    let topbarItemClick = false;
    let configClick = false;

    const { usuario } = useSelector(state => ({
        usuario: state.usuario,
    }))
    
    const menu = [
        {
            label: 'Innova', icon: 'pi pi-fw pi-home',
            items: [
                {
                    label: 'INICIO', icon: 'pi pi-fw pi-home',clave:'Inicio',
                    items: [
                        {
                            label: 'Dashboard', icon: 'pi pi-fw pi-home',clave:'Dashboard', to: '/', breadCrumb: [
                                { label: 'Inicio' },
                                { label: 'Dashboard' }
                            ]
                        },
                    ]
                },
                /*
                {
                    label: 'CONFIGURADOR', icon: 'pi pi-fw pi-home',clave:'configuraciones',
                    items: [
                        {
                            label: 'Conf.Horario Curso', icon: 'pi pi-fw pi-home',clave:'*', to: '/configurador/horario-curso', 
                            breadCrumb: [
                                { label: 'Configurador' },
                                { label: 'Configurador Horario Curso' }
                            ]
                        },
                    ]
                }, */
                {
                    label: 'MANTENEDOR', icon: 'pi pi-fw pi-home',clave:'mantenedor',
                    items: [
                        {
                            label: 'Colegio', icon: 'pi pi-fw pi-home',clave:'colegio', to: '/Mantenedor/Colegio',
                            breadCrumb: [
                                { label: 'Mantenedor' },
                                { label: 'Colegio' }
                            ]
                        },
                        {
                            label: 'Día Festivo', icon: 'pi pi-fw pi-home',clave:'dias_festivos', to: '/Mantenedor/Festivo',
                            breadCrumb: [
                                { label: 'Mantenedor' },
                                { label: 'Festivo' }
                            ]
                        },
                        {
                            label: 'Conf.Horario Curso', icon: 'pi pi-fw pi-home',clave:'*', to: '/mantenedor/horario-curso', 
                            breadCrumb: [
                                { label: 'Configurador' },
                                { label: 'Configurador Horario Curso' }
                            ]
                        },
                        /*
                        {
                            label: 'Profesional', icon: 'pi pi-fw pi-home',clave:'colegio', to: '/Mantenedor/Profesional',
                            breadCrumb: [
                                { label: 'Mantenedor' },
                                { label: 'Profesional' }
                            ]
                        }*/
                    ]
                },
                {
                    label: 'REGISTROS', icon: 'pi pi-fw pi-star-o',clave:'registros',
                    items: [
                        {
                            label: 'Ficha del Estudiante', icon: 'pi pi-fw pi-id-card',clave:'ficha_estudiante', to: '/Registros/Ficha',
                            breadCrumb: [
                                { label: 'Registros' },
                                { label: 'Ficha del Estudiante' }
                            ]
                        },
                        {
                            label: 'Matrícula Pie', icon: 'pi pi-fw pi-check-square',clave:'matricula_pie', to: '/Registros/Matricula',
                            breadCrumb: [
                                { label: 'Registros' },
                                { label: 'Matrícula Pie' }
                            ]
                        },
                        {
                            label: 'Asistencia', icon: 'pi pi-fw pi-check-square',clave:'matricula_pie', to: '/Registros/Asistencia',
                            breadCrumb: [
                                { label: 'Registros' },
                                { label: 'Asistencia' }
                            ]
                        }

                    ]
                },
                {
                    label: 'FORMULARIOS', icon: "pi pi-fw pi-bookmark",clave:'formularios',
                    items: [
                        {
                            label: 'FUDEI | Fu-Revaluación', icon: 'pi pi-fw pi-align-left',clave:'fudei_revaluacion', to: '/formularios/fudei',
                            breadCrumb: [
                                { label: 'FORMULARIOS MINEDUC' },
                                { label: 'Form.Único Eval.Inte' },
                                { label: 'FUDEI | Fu-Revaluación' }
                            ]
                        }
                    ]
                },
                {
                    label: 'OTROS FORMULAR.', icon: "pi pi-fw pi-bookmark",clave:'otros_formularios',
                    items: [
                        {
                            label: 'Anamnesis', icon: 'pi pi-fw pi-align-left',clave:'anamnesis', to: '/otros-1/anamnesis',
                            breadCrumb: [
                                { label: 'OTROS FORMULARIO' },
                                { label: 'Anamnesis' }
                            ]
                        },
                        {
                            label: 'Autorización', icon: 'pi pi-fw pi-align-left',clave:'autorizacion', to: '/otros-2/autorizacion',
                            breadCrumb: [
                                { label: 'OTROS FORMULARIO' },
                                { label: 'Autorización' }
                            ]
                        },
                        {
                            label: 'Certif. Nacimiento', icon: 'pi pi-fw pi-align-left',clave:'certificado_nacimiento', to: '/otros-3/certificado_nacimiento',
                            breadCrumb: [
                                { label: 'OTROS FORMULARIO' },
                                { label: 'Certificado Nacimiento' }
                            ]
                        },
                        {
                            label: 'Ev. Psicopedagógica', icon: 'pi pi-fw pi-align-left',clave:'evaluacion_psicopedagogica_curricular', to: '/otros-4/evaluacion_psicopedagogica_curricular',
                            breadCrumb: [
                                { label: 'OTROS FORMULARIO' },
                                { label: 'Evaluación Psicopedagógica' }
                            ]
                        },
                        {
                            label: 'Interconsulta', icon: 'pi pi-fw pi-align-left',clave:'interconsulta', to: '/otros-5/interconsulta',
                            breadCrumb: [
                                { label: 'OTROS FORMULARIO' },
                                { label: 'Interconsulta' }
                            ]
                        },
                        {
                            label: 'Valoración Salud', icon: 'pi pi-fw pi-align-left',clave:'valoracion_salud', to: '/otros-6/valoracion_salud',
                            breadCrumb: [
                                { label: 'OTROS FORMULARIO' },
                                { label: 'Valoración Salud' }
                            ]
                        },
                        {
                            label: 'Informe a la Familia', icon: 'pi pi-fw pi-align-left',clave:'informe_familia', to: '/otros-7/informe_familia',
                            breadCrumb: [
                                { label: 'OTROS FORMULARIO' },
                                { label: 'Informe a la Familia' }
                            ]
                        }
                    ]
                },
                {
                    label: 'LIBRO', icon: 'pi pi-fw pi-home',clave:'seguridad',
                    items: [
                        {
                            label: 'Pie', icon: 'pi pi-fw pi-home',clave:'usuarios', to: '/libro/pie',
                            breadCrumb: [
                                { label: 'Libro' },
                                { label: 'Pie' }
                            ]
                        }
                    ]
                },
                {
                    label: 'SEGURIDAD', icon: 'pi pi-fw pi-home',clave:'seguridad',
                    items: [
                        {
                            label: 'Usuarios', icon: 'pi pi-fw pi-home',clave:'usuarios', to: '/seguridad/Usuario',
                            breadCrumb: [
                                { label: 'Seguridad' },
                                { label: 'Usuarios' }
                            ]
                        },
                        {
                            label: 'Perfiles & Accesos', icon: 'pi pi-fw pi-home',clave:'roles', to: '/seguridad/PerfilAcceso',
                            breadCrumb: [
                                { label: 'Seguridad' },
                                { label: 'Perfiles & Accesos' }
                            ]
                        }
                    ]
                }
            ]
        },

    ];

    const findMenuElimina = (data,menu,submenu,nivel) => {
        
        if(nivel==1){
            if(data[menu]==undefined){
                return true;
            }else{
               if (Object.entries(data[menu]).length===0){
                return true;
               }else{
                return false;
               }
            }
        }
        if(nivel==2){

            if(submenu==='*'){
                return false;
            }

            if(data[menu][submenu]==undefined){
                return true;
            }else{
                if (Object.entries(data[menu][submenu]).length===0){
                 return true;
                }else{
                 return false;
                }
             }
        }
    };

    //debugger;
    if(!usuario.superusuario){
        menu[0].items?.map((me, index1) => {
            if(findMenuElimina(usuario.permisos,me.clave,'',1)){
                delete menu[0].items[index1];
             }else{
                me.items?.map((sub, index2) => {
                    if( findMenuElimina(usuario.permisos,me.clave,sub.clave,2)){
                        delete menu[0].items[index1].items[index2];
                     }
                 })
             }
         })
    }

    const routers = [
        { path: '/', component: Dashboard, exact: true },
        { path: '/dashboards/generic', component: Dashboard },
        { path: '/dashboards/dashboard_banking', component: DashboardBanking },
        //{ path: '/configurador/horario-curso', component: PageHorarioCurso },
        { path: '/mantenedor/horario-curso', component: PageHorarioCurso },
        { path: '/mantenedor/colegio', component: PageColegio },
        { path: '/mantenedor/profesional', component: PageProfesional },
        { path: '/mantenedor/festivo', component: PageFestivo },
        { path: '/registros/ficha', component: PageFicha },
        { path: '/registros/matricula', component: PageMatricula },
        { path: '/registros/asistencia', component: PageAsistencia },
        { path: '/formularios/fudei', component: PageFudei },
        { path: '/otros-1/:idOtro', component: PageOtro },
        { path: '/otros-2/:idOtro', component: PageOtro },
        { path: '/otros-3/:idOtro', component: PageOtro },
        { path: '/otros-4/:idOtro', component: PageOtro },
        { path: '/otros-5/:idOtro', component: PageOtro },
        { path: '/otros-6/:idOtro', component: PageOtro },
        { path: '/otros-7/:idOtro', component: PageOtro },
        { path: '/seguridad/Usuario', component: PageUsuario },
        { path: '/seguridad/PerfilAcceso', component: PagePerfilAcceso },
        { path: '/Acceso', component: Access },
        { path: '/Profile', component: PageProfile },
        // Libro Pie
        { path: '/libro/pie', component: PageLibro }
        
    ];

    const onInputStyleChange = (inputStyle) => {
        setInputStyle(inputStyle);
    };

    const onRippleChange = (e) => {
        PrimeReact.ripple = e.value;
        setRipple(e.value);
    };

    const onDocumentClick = () => {
        if (!topbarItemClick) {
            setActiveTopbarItem(null);
            setTopbarMenuActive(false);
        }

        if (!menuClick) {
            if (isHorizontal() || isSlim()) {
                setMenuActive(false);
            }

            hideOverlayMenu();
        }

        if (configActive && !configClick) {
            setConfigActive(false);
        }

        menuClick = false;
        topbarItemClick = false;
        configClick = false;
    };

    const onProfileClick = (e) => {
        setProfileExpanded(prevProfileExpanded => !prevProfileExpanded);
    };

    const onMenuClick = () => {
        menuClick = true;
    };

    const onMenuitemClick = (event) => {

        if (event.item.to !== undefined) {
            setItemsBreadCrumb(event.item.breadCrumb)
        }

        //setItemsBreadCrumb

        if (!event.item.items) {
            hideOverlayMenu();
        }

        if (!event.item.items && (isSlim() || isHorizontal())) {
            setMenuActive(false);
        }
    };

    const onRootMenuitemClick = () => {
        setMenuActive(prevMenuActive => !prevMenuActive);
    };

    const onMenuButtonClick = (event) => {
        menuClick = true;
        setTopbarMenuActive(false);

        if (menuMode === 'overlay') {
            setOverlayMenuActive(prevOverlayMenuActive => !prevOverlayMenuActive);
        }
        else {
            if (isDesktop())
                setStaticMenuDesktopInactive(prevStaticMenuDesktopInactive => !prevStaticMenuDesktopInactive);
            else
                setStaticMenuMobileActive(prevStaticMenuMobileActive => !prevStaticMenuMobileActive);
        }

        event.preventDefault();
    };

    const onTopbarMenuButtonClick = (event) => {
        topbarItemClick = true;
        setTopbarMenuActive(prevTopbarMenuActive => !prevTopbarMenuActive);
        hideOverlayMenu();
        event.preventDefault();
    };

    const onTopbarItemClick = (e) => {
        topbarItemClick = true;

        if (activeTopbarItem === e.item)
            setActiveTopbarItem(null)
        else
            setActiveTopbarItem(e.item);

        e.originalEvent.preventDefault();
    };

    const loadPageProfile = () => {
        history.push('/Profile')
        setItemsBreadCrumb([{ label: 'Profile' }])
    };

    const hideOverlayMenu = () => {
        setOverlayMenuActive(false);
        setStaticMenuMobileActive(false);
    };

    const isDesktop = () => {
        return window.innerWidth > 1024;
    };

    const isHorizontal = () => {
        return menuMode === 'horizontal';
    };

    const isSlim = () => {
        return menuMode === 'slim';
    };

    const isMenuVisible = () => {
        if (isDesktop()) {
            if (menuMode === 'static')
                return !staticMenuDesktopInactive;
            else if (menuMode === 'overlay')
                return overlayMenuActive;
            else
                return true;
        } else {
            if (staticMenuMobileActive)
                return true;
            else if (menuMode === 'overlay')
                return overlayMenuActive;
            else
                return true;
        }
    };

    const onMenuModeChange = (e) => {
        setMenuMode(e.value);
        setStaticMenuDesktopInactive(false);
        setOverlayMenuActive(false);

        if (e.value === 'horizontal') {
            setProfileMode('top');
        }
    };

    const onMenuColorChange = (e) => {
        setDarkMenu(e.value);
    };

    const onProfileModeChange = (e) => {
        setProfileMode(e.value);
    };

    const onConfigClick = () => {
        configClick = true;
    };

    const onConfigButtonClick = () => {
        setConfigActive(prevConfigActive => !prevConfigActive);
        configClick = true;
    };

    const onLayoutColorChange = (color) => {
        setLayout(color);
    };

    const onThemeChange = (color) => {
        setTheme(color);
    };

    let containerClassName = classNames('layout-wrapper', {
        'menu-layout-static': menuMode !== 'overlay',
        'menu-layout-overlay': menuMode === 'overlay',
        'layout-menu-overlay-active': overlayMenuActive,
        'menu-layout-slim': menuMode === 'slim',
        'menu-layout-horizontal': menuMode === 'horizontal',
        'layout-menu-static-inactive': staticMenuDesktopInactive,
        'layout-menu-static-active': staticMenuMobileActive,
        'p-input-filled': inputStyle === 'filled',
        'p-ripple-disabled': !ripple,
    });
    let menuClassName = classNames('layout-menu-container', { 'layout-menu-dark': darkMenu, 'layout-menu-container-inactive': !isMenuVisible() });

    const { loading,mensaje } = useSelector(state => ({
        loading: (Object.keys(state.loading).length === 0? state.loading:state.loading.estado),
        mensaje: (Object.keys(state.loading).length === 0? "Loading..":state.loading.mensaje),
    }))

    resetCache();

    return (

        <LoadingOverlay
            active={loading}
            // spinner={<BounceLoader />}
            spinner={true}
            text={mensaje}
            styles={{
                overlay: base => ({
                  ...base,
                  position: 'fixed',
                  zIndex: 9999999,
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }),
                content: base => ({
                  ...base,
                  position: 'relative', // Para permitir que el texto y el spinner estén centrados
                  textAlign: 'center',
                }),
                spinner: base => ({
                  ...base,
                  width: '100px', // Ajusta el tamaño del spinner según sea necesario
                  height: '100px', // Ajusta el tamaño del spinner según sea necesario
                }),
              }}
            >

            <div className={containerClassName} onClick={onDocumentClick}>


                <div className="layout-wrapper-content">

                    <AppTopBar topbarMenuActive={topbarMenuActive} profileMode={profileMode} horizontal={isHorizontal()} activeTopbarItem={activeTopbarItem}
                        onMenuButtonClick={onMenuButtonClick} onTopbarMenuButtonClick={onTopbarMenuButtonClick} onTopbarItemClick={onTopbarItemClick} loadPageProfile={loadPageProfile}></AppTopBar>

                    <div className={menuClassName} onClick={onMenuClick}>
                        <div className="menu-scroll-content">
                            {profileMode === 'inline' && menuMode !== 'horizontal' && <AppInlineProfile onProfileClick={onProfileClick} expanded={profileExpanded}></AppInlineProfile>}

                            <AppMenu model={menu} menuMode={menuMode} active={menuActive} onMenuitemClick={onMenuitemClick} onRootMenuitemClick={onRootMenuitemClick}></AppMenu>
                        </div>
                    </div>

                    <div className="layout-main" style={{ paddingTop: '60px' }}>
                        <div style={{ position: 'fixed', zIndex: 2, width: '100%' }}>
                            <BreadCrumb model={itemsBreadCrumb} home={home}></BreadCrumb>
                        </div>
                        <div style={{ marginTop: '42px' }}>

                            {
                                routers.map((router, index) => {
                                    if (router.exact) {

                                        return <Route key={`router${index}`} path={router.path} exact component={router.component} />
                                    }

                                    return <Route key={`router${index}`} path={router.path} component={router.component} />
                                })
                            }
                        </div>
                    </div>


                    {/* 
                <AppConfig configActive={configActive} menuMode={menuMode} onMenuModeChange={onMenuModeChange} darkMenu={darkMenu} onMenuColorChange={onMenuColorChange}
                    profileMode={profileMode} onProfileModeChange={onProfileModeChange} onConfigClick={onConfigClick} onConfigButtonClick={onConfigButtonClick}
                    layout={layout} onLayoutColorChange={onLayoutColorChange} theme={theme} onThemeChange={onThemeChange}
                    rippleActive={ripple} onRippleChange={onRippleChange} inputStyle={inputStyle} onInputStyleChange={onInputStyleChange}></AppConfig>

                <div className="layout-mask modal-in"></div>  */}


                </div>
            </div>
        </LoadingOverlay>
    );
}

export default App;
